import type { BrandConfigurationFactory } from '../common/interfaces/BrandConfigurationFactory';
import enGB from './locale/en-GB.json';

// TODO: configure this brand properly
export const ourHabitasBrandConfig: BrandConfigurationFactory = ({
  isProduction,
}) => ({
  chainCode: 'ourhabitas',
  themeKey: 'ourhabitas',
  name: 'Our Habitas',
  hotels: [
    {
      referenceId: 'ourhabitas.caravanhatta-dubai',
      code: 'ourhabitas.caravanhatta-dubai',
      name: 'Our Habitas Hatta',
      dialect: 'ohip',
    },
    {
      referenceId: 'ourhabitas.bacalar-bacalar',
      code: 'ourhabitas.bacalar-bacalar',
      name: 'Our Habitas Bacalar',
      dialect: 'ohip',
    },
    {
      referenceId: 'ourhabitas.tulum-tulum',
      code: 'ourhabitas.tulum-tulum',
      name: 'Our Habitas Tulum',
      dialect: 'ohip',
    },
  ],
  homeUrl: 'https://www.ourhabitas.com',
  domains: [
    'booking.ourhabitas.com',
    'ourhabitas.ui.dev.ennismore.io',
    'ourhabitas.ui.staging.ennismore.io',
    'ourhabitas.ui.live.ennismore.io',
  ],
  i18n: {
    locales: ['en-GB'],
  },
  maxRoomCountPerBooking: 3,
  supportedRoomOccupancyConfigurations: [{ adults: 1 }, { adults: 2 }],
  legal: {
    urls: {
      en: {
        privacyPolicy: 'https://www.ourhabitas.com/privacy-policy/',
        cookiePolicy: 'https://www.ourhabitas.com/privacy-policy/',
        termsOfUse: 'https://www.ourhabitas.com/reservation-policies/',
        contact: 'https://www.ourhabitas.com/contact-us/',
      },
    },
  },
  showRoomTotalInBreakdown: true,
  showTaxTotalInBreakdown: true,
  showAveragePricePerNight: true,

  features: {
    bookingManagement: true,
  },
  translationOverrides: {
    'en-GB': enGB,
  },
  analytics: {
    gtm: {
      containerId: isProduction ? 'GTM-MTZ7L2J' : '',
    },
    cookieConsent: {
      provider: 'onetrust',
      oneTrustId: 'e0dcd052-97d1-4dbf-a178-2e750c6720cc',
    },
  },
});
